"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStylesConfig = void 0;
var defaultStylesConfig = {
  classesStyles: {},
  enableCSSInlineProcessing: true,
  enableUserAgentStyles: false,
  idsStyles: {},
  tagsStyles: {},
  baseStyle: {
    fontSize: 14,
    whiteSpace: 'normal'
  }
};
exports.defaultStylesConfig = defaultStylesConfig;